var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-modal-confirm',{attrs:{"title":_vm.Info.Modal.Deactivate.Title,"width":500},on:{"init":_vm.handle_Init,"submit":_vm.handleSubmit}},[_vm._v(" "+_vm._s(_vm.Info.Modal.Deactivate.Message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }